import dayjs from 'dayjs';
import { formatDollars } from '@/utils/helperFunctions';
import type { CancelSubscriptionBillingPreview } from './types';

type BillingLike = {
  period_start?: string;
  period_end?: string;
  total_amount?: number | string;
  total_addon_amount?: number | string;
};

/** Builds the confirmation modal summary from current billing API payload. */
export function buildCancelSubscriptionBillingPreview(
  billing: BillingLike | null | undefined
): CancelSubscriptionBillingPreview | null {
  if (!billing?.period_start || !billing?.period_end) return null;

  const start = dayjs(billing.period_start);
  const end = dayjs(billing.period_end);

  if (!start.isValid() || !end.isValid()) return null;

  const daysUsed = Math.max(1, end.diff(start, 'day') + 1);

  const sameMonth = start.month() === end.month() && start.year() === end.year();
  const billingPeriodLabel = sameMonth
    ? `${start.format('MMMM D')} – ${end.format('D, YYYY')}`
    : `${start.format('MMMM D, YYYY')} – ${end.format('MMMM D, YYYY')}`;

  const total = Number(billing.total_amount) || 0;
  const addonsTotal = Number(billing.total_addon_amount) || 0;
  const packageTotal = Math.max(total - addonsTotal, 0);

  return {
    billingPeriodLabel,
    daysUsed,
    packageTotalFormatted: formatDollars(packageTotal),
    addonsTotalFormatted: formatDollars(addonsTotal),
    totalFormatted: formatDollars(total)
  };
}
